import { render } from "./App.vue?vue&type=template&id=5017bf08"
const script = {}

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__